import { render, staticRenderFns } from "./ResearchNavigation.vue?vue&type=template&id=45774f0f&scoped=true&"
import script from "./ResearchNavigation.vue?vue&type=script&lang=js&"
export * from "./ResearchNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ResearchNavigation.vue?vue&type=style&index=0&id=45774f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45774f0f",
  null
  
)

export default component.exports